import IconAdd from "@/components/svg/IconAdd";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { DataTableNew } from "@/shared/common/table-components/tasks/components/data-table";
import DataTableColumnHeader from "@/shared/common/table-components/tasks/components/data-table-column-header";
import { newActiveColumnsViews, newAddColumnsFields, newDeleteColumnsViews, newFetchColumnsViews } from "@/store/actions/ColumnsViewsActine";
import { DotsHorizontalIcon, Pencil2Icon } from "@radix-ui/react-icons";
import { CirclePlay, TrashIcon } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AddViewModal from "./AddViewModal";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import FieldsDnd from "./FieldsDnd";

const ListViewModal = (props) => {
     const { show, onHide, viewFields, setActiveFields, activeFields, setViewFields, setSearchValue, searchValue, isLoading, viewId, setViewId, isLoadingFields, name, setName, sectionType, setIsRefetch } = props;
     const dispatch = useDispatch();
     const views = useSelector(state => state.views)
     const [modalShow, setModalShow] = useState(false);
     const [viewsData, setViewsData] = useState([]);
     const [fetchId, setFetchId] = useState(null);
     const [indexOfLastItem, setIndexOfLastItem] = useState(1)
     const [indexOfFirstItem, setIndexOfFirstItem] = useState(1)
     const [currentPage, setCurrentPage] = useState(1);
     const [itemsPerPage, setItemsPerPage] = useState(10);

     const onChange = (filter) => {
          setCurrentPage(filter.page)
          setItemsPerPage(filter.perPage)
          dispatch(newFetchColumnsViews(sectionType, filter))
     }

     useEffect(() => {
          dispatch(newFetchColumnsViews(sectionType, { page: 1, perPage: 10 }))
     }, [dispatch])

     useEffect(() => {
          setViewsData(views?.records)
     }, [views])

     useEffect(() => {
          setIndexOfLastItem(currentPage * itemsPerPage);
          setIndexOfFirstItem((currentPage * itemsPerPage) - itemsPerPage);
     }, [currentPage, itemsPerPage])

     const handelDelete = (data) => {
          if (data?.status === 'Active') {
               toast.error('Active view cannot be deleted.')
               return;
          }
          const payload = {
               action: "delete",
               viewId: data?.id
          }
          dispatch(newDeleteColumnsViews(payload, sectionType))
     }

     const handelEdit = (data) => {
          setModalShow(true)
          setFetchId(data?.id)
     }

     const handleActive = (data) => {
          const payload = {
               action: "active",
               viewId: data?.id
          }
          dispatch(newActiveColumnsViews(payload, sectionType)).then((res) => {
               if (res?.success) {
                    setIsRefetch((prev) => prev + 1);
               }
          })
     }

     const handleViewId = (id, name) => {
          if (viewId === id) {
               return;
          } else {
               setViewId(id);
               setName(name);
          }
     }

     const data = useMemo(() => Array.isArray(viewsData) && viewsData.length > 0 ? viewsData.map((item, index) => {
          return {
               index: indexOfFirstItem + index + 1,
               name: item?.name,
               status: item?.active ? 'Active' : '-',
               id: item?._id,
          }
     }) : [], [viewsData, indexOfFirstItem])

     const columns = [
          {
               id: "checkbox",
               // header: ({ column }) => <Checkbox />,
               cell: ({ row }) => {
                    return <Checkbox className="cursor-pointer rounded-[4px]" checked={viewId === row?.original?.id} onCheckedChange={() => handleViewId(row?.original?.id, row?.original?.name)} />
               },
               enableSorting: true,
          },
          {
               accessorKey: "name",
               header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
               cell: ({ row }) => <span>{row?.original?.name}</span>,
               enableSorting: true,
          },
          {
               accessorKey: "status",
               header: ({ column }) => <DataTableColumnHeader column={column} title="Status" />,
               cell: ({ row }) => <span className={`${row?.original?.status === 'Active' ? 'text-green-600' : ''}`}>{row?.original?.status}</span>,
               enableSorting: false,
          },
          {
               id: "actions",
               enableHiding: false,
               header: <span className="flex items-center justify-end">Actions</span>,
               cell: ({ row }) => (
                    <div className="flex items-center justify-end">
                         <DropdownMenu>
                              <DropdownMenuTrigger asChild>
                                   <Button variant="ghost" className="p-0">
                                        <span className="sr-only">Open menu</span>
                                        <DotsHorizontalIcon strokeWidth={"2.2"} className="h-5 w-5 text-textV2" />
                                   </Button>
                              </DropdownMenuTrigger>
                              <DropdownMenuContent align="end">
                                   <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => handelEdit(row?.original)}><Pencil2Icon strokeWidth={"2.2"} className='text-themeV2 w-4 h-4' /> Edit</DropdownMenuItem>
                                   <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => handelDelete(row?.original)}><TrashIcon strokeWidth={"2.2"} className='text-red w-4 h-4' /> Remove</DropdownMenuItem>
                                   <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => handleActive(row?.original)}><CirclePlay strokeWidth={"2.2"} className='text-green-600 w-4 h-4' /> Active</DropdownMenuItem>
                              </DropdownMenuContent>
                         </DropdownMenu>
                    </div>
               ),
          }
     ]

     const rightHeaderButtons = [
          {
               icon: <IconAdd className="w-4 h-4 text-white transition duration 200" />,
               text: 'Add View',
               onClick: () => {
                    setModalShow(true)
               },
               variant: '',
               additionalClass: ""
          },
     ];

     const handleSave = () => {
          const toleranceFieldsData = activeFields?.filter(field => field?.fieldType === 'toleranceFields')?.map((field, index) => {
               return {
                    field: field?.toleranceParameter,
                    toleranceParameterFields: field?._id,
                    index: index
               }
          })
          const columns = activeFields?.filter(field => field?.fieldType !== 'toleranceFields')?.map((field, index) => {
               return {
                    field: field?._id,
                    index: index
               }
          })
          const payload = {
               viewId: viewId,
               section: sectionType,
               name: name,
               columns: columns,
               toleranceFields: toleranceFieldsData
          }
          dispatch(newAddColumnsFields(payload)).then((res) => {
               if (res?.success) {
                    onHide()
                    setIsRefetch((prev) => prev + 1);
               }
          })
     }

     return (
          <Dialog open={show} onOpenChange={onHide}>
               <DialogContent className="sm:max-w-[1200px] w-[95%]">
                    <DialogHeader>
                         <DialogTitle className="text-center">Views</DialogTitle>
                    </DialogHeader>
                    <div className="flex justify-between items-start gap-2">
                         <div className="w-1/2">
                              <DataTableNew data={data} columns={columns} onChange={onChange} filterName={'name'}
                                   isRightNew={true}
                                   isOldHeaderHide={true}
                                   isRightSearch={true}
                                   isRightHeaderButtons={true}
                                   rightHeaderButtons={rightHeaderButtons}
                                   viewTable={true}
                              />
                         </div>
                         <div className="w-1/2 flex items-center justify-center gap-1">
                              <FieldsDnd viewFields={viewFields} setActiveFields={setActiveFields} activeFields={activeFields} setViewFields={setViewFields} setSearchValue={setSearchValue} searchValue={searchValue} isLoading={isLoading} isLoadingFields={isLoadingFields} viewId={viewId} />
                         </div>
                    </div>
                    <DialogFooter className="flex !justify-between !items-center">
                         <span className="text-xs">
                              <b>Note</b> : You can update the view list only when you
                              select one of the lists!
                         </span>
                         <div className="flex items-center gap-2">
                              <Button variant="outline" onClick={onHide}>
                                   Cancel
                              </Button>
                              <Button onClick={handleSave} disabled={activeFields?.length === 0}>Save</Button>
                         </div>

                    </DialogFooter>
               </DialogContent>
               <AddViewModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    sectionType={sectionType}
                    fetchId={fetchId}
               />
          </Dialog>
     )
}

export default ListViewModal; 